<template>
<div class="contentBox certificationInfoPage">
    <div class="pageTitle">
        <h1>企业认证</h1>
    </div>
    <div class="certificationInfoBox">
        <div class="infoItem">
            <span class="title">企业名称</span>
            <el-input class="w600" v-model.trim="organName" />
        </div>
        <div class="infoItem">
            <span class="title">营业执照</span>
            <div class="uploadImgBox">
                <el-form :model="form1">
                    <el-form-item>
                        <el-upload ref="upload" 
                            action="#" 
                            accept="image/png,image/gif,image/jpg,image/jpeg" 
                            list-type="picture-card"
                            :auto-upload="false" 
                            :on-exceed="handleExceed" 
                            :before-upload="handleBeforeUpload" 
                            :on-preview="handlePictureCardPreview" 
                            :on-change="handleLicChangePic"
                        >
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                            <span class="uploadTips">上传图片</span>
                        </el-upload>

                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-button size="small" type="primary" @click="uploadFile">立即上传</el-button>
                        <el-button size="small">取消</el-button>
                    </el-form-item> -->
                </el-form>
            </div>
            <p class="tips">选择营业执照扫描件</p>
        </div>
        <div class="infoItem downloadItem">
            <span class="title">授权书</span>
            <button class="downloadFile" @click="downloadAuthTmpl">授权书下载</button>
        </div>
        <div class="infoItem">
            <span class="title"></span>
            <div class="uploadImgBox">
                <el-form :model="form2">
                    <el-form-item>
                        <el-upload ref="upload" 
                            action="#" 
                            accept="image/png,image/gif,image/jpg,image/jpeg" 
                            list-type="picture-card"
                            :auto-upload="false" 
                            :on-exceed="handleExceed" 
                            :before-upload="handleBeforeUpload" 
                            :on-preview="handlePictureCardPreview" 
                            :on-change="handleAuthChangePic"
                        >
                            <i class="el-icon-plus avatar-uploader-icon"></i>
                            <span class="uploadTips">上传图片</span>
                        </el-upload>

                        <el-dialog :visible.sync="dialogVisible">
                            <img width="100%" :src="dialogImageUrl" alt="">
                        </el-dialog>
                    </el-form-item>
                    <!-- <el-form-item>
                        <el-button size="small" type="primary" @click="uploadFile">立即上传</el-button>
                        <el-button size="small">取消</el-button>
                    </el-form-item> -->
                </el-form>
            </div>
            <p class="tips">选择授权书扫描件</p>
        </div>
        <div class="actionBtnBox">
            <button class="submitBtn" @click="saveCertification">提交</button>
        </div>
    </div>
</div>
</template>

<script>
    import common from '../../../common.vue';
    import OSS from 'ali-oss';
    import fileDownload from 'js-file-download';

    export default {
        name: "Certification",
        data() {
            return {
                // 机构名称
                organName: "",
                // 营业执照扫描件文件
                licFile: null,
                // 授权书扫描件文件
                authorizationFile: null,

                dialogImageUrl: '',
                dialogVisible: false,
                form1: {},
                form2: {},
            };
        },
        methods: {
            // 上传文件之前的钩子
            handleBeforeUpload(file) {
                if (!(file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg' || file.type === 'image/jpeg')) {
                    this.$notify.warning({
                        title: '警告',
                        message: '请上传格式为image/png, image/gif, image/jpg, image/jpeg的图片'
                    })
                }
                let size = file.size / 1024 / 1024;
                if (size > 20) {
                    this.$notify.warning({
                        title: '警告',
                        message: '图片大小必须小于20M'
                    })
                }
            },

            // 新上传的图片替换老的图片
            handleAuthChangePic(file, fileList) {
                if (fileList.length > 1) {
                    fileList.splice(0, 1);
                }
                this.authenticationFile = file.raw;
            },
            handleLicChangePic(file){
                if(file){
                    this.licFile = file.raw;
                }
            },
            // 文件超出个数限制时的钩子
            handleExceed() {
                alert('只可以上传一个文件');
            },
            // 点击文件列表中已上传的文件时的钩子
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            /**
             * 获取oss上传授权
             */
            getCredential(callback){
                let _this = this;

                _this.$axios.post(common.OSS_PRI_CREDENTIAL_URL).then(function (res) {
                    let r = res.data;
                    if (r && r.code === 0) {
                        callback && callback(r);
                    }
                    r.code < 0 && _this.jumpPage('/login');
                });
            },
            /**
             * 根据服务器上返回的授权构建oss配置
             */
            buildConfig(credential){
                let _this = this;
                _this.ossConfig = Object.assign({
                    refreshSTSToken: async () => {
                        _this.getCredential(function(r){
                            return r;
                        });
                    }
                }, credential);
            },
            /**
             * 保存申请材料
             */
            saveCertification(){
                let _this = this;
                // 检查输入信息
                if(common.isEmpty(this.organName)){
                    _this.$notify.warning({
                        title: '警告',
                        message: '请输入机构名称'});
                }
                if(!this.licFile){
                    _this.$notify.warning({
                        title: '警告',
                        message: '请选择营业执照扫描件'});
                }
                if(!this.authenticationFile){
                    _this.$notify.warning({
                        title: '警告',
                        message: '请选择授权书扫描件'});
                }
                // 上传文件到oss
                (async () => {
                    let ossKeys = await this.ossUploadFiles([this.licFile,this.authenticationFile]);
                    console.log(ossKeys);
                    // 保存
                    _this.$axios.post(common._BASE_ + '/sponsor/saveOrganInfo',
                        this.$qs.stringify({organName: _this.organName, licURI: ossKeys[0], authURI: ossKeys[1]})).then(function (res) {
                        let r = res.data;
                        if (r && r.code === 0) {
                            _this.$notify({
                                title: '成功',
                                message: '机构认证信息已提交，请耐心等待审核',
                                type: 'success'
                            });
                        }
                        r.code < 0 && _this.jumpPage('/login');
                    });
                })();
            },

            /**
             * 上传多个文件
             * 循环await说明，参见https://stackoverflow.com/questions/37576685/using-async-await-with-a-foreach-loop
             * @param files
             */
            async ossUploadFiles(files){
                if(!files || files.length === 0){ return null; }

                let _this = this,
                    ossClient = new OSS(this.ossConfig);
                let ossKeys = [];
                await files.reduce(async (promise, file) => {
                    await promise;
                    let fileName = common.guid() + "." + common.fileExt(file.name),
                        ossKey = common.assertPath(_this.ossConfig.folder) + fileName;
                    console.info('上传' + ossKey);
                    await ossClient.put(ossKey, file);
                    ossKeys.push(ossKey);
                }, Promise.resolve());
                console.info(ossKeys);
                return ossKeys;
            },
            // 下载授权书模板
            downloadAuthTmpl(){
                this.$axios.get(common.AUTH_TMPL_DOWNLOAD, {
                    responseType: 'blob',
                }).then(res => {
                    fileDownload(res.data, 'Quicklive企业认证授权模板.docx');
                });
            }
        },
        mounted(){
            let _this = this;
            _this.getCredential(function (c) {
                _this.buildConfig(c);
            });
        }
    };
</script> 

<style lang="less">
.certificationInfoPage {
    .certificationInfoBox {
        width: 1210px;
        background: #ffffff;
        border: 1px solid #e8e8e8;
        padding: 30px 0 43px 32px;
        font-size: 14px;

        .infoItem {
            display: flex;
            margin-bottom: 22px;
        }

        .downloadItem {
            margin-bottom: 16px;
        }

        .w600 {
            width: 600px;
        }

        .title {
            width: 74px;
        }

        .uploadImgBox {
            // width: 800px;
            height: 160px;
            position: relative;

            .el-upload--picture-card {
                width: 240px;
                height: 148px;
                background: #f5f6f7;
                border: 1px solid #c1c5c5;
                border-radius: 4px;
                position: relative;
                cursor: pointer;

                .uploadTips {
                    width: 100%;
                    position: absolute;
                    left: 0;
                    top: 0;
                    z-index: 10;
                    color: #a2a9ab;
                    text-align: center;
                    padding-top: 26px;
                }
            }

            .el-upload--picture-card:hover {
                border-color: #409eff;

            }

            .el-upload-list--picture-card {
                .el-upload-list__item-thumbnail {
                    width: 100%;
                    height: auto;
                }
            }
        }

        .tips {
            color: #55565f;
            margin-left: 23px;
        }

        .downloadFile {
            width: 128px;
            height: 40px;
            background: #ffffff;
            border: 1px solid #c1c5c5;
            border-radius: 4px;
        }

        .downloadFile:hover {
            background: #306ff6;
            color: #fff;
            border: none;
        }

        .actionBtnBox {
            padding-left: 74px;

            button {
                width: 110px;
                height: 40px;
                border-radius: 4px;
            }

            .resetBtn {
                background: #ffffff;
                border: 1px solid #c1c5c5;
            }

            .resetBtn:hover {
                background: #306ff6;
                color: #fff;
                border: none;
            }

            .submitBtn {
                background: #076eff;
                color: #fff;
                margin-right: 22px;
            }

            .submitBtn:hover {
                background: #4aa3f8;
            }
        }
    }
}
</style>